const LifeRisk = {
    options: [
        {value: '', label: 'Todos'},
        {value: 'LOW', label: 'Baixo'},
        {value: 'MEDIUM', label: 'Moderado'},
        {value: 'HIGH', label: 'Elevado'}
    ],

    getLifeRisk: (includeOptionAll = false, nullOption = false) => {
        let options = LifeRisk.options;

        if (!includeOptionAll) options = options.filter(i => i.value !== "");
        if (nullOption) options.unshift({value: null, label: "Sem risco"});

        return options;
    },

    toView: (type) => {
        if (!type) return "";

        return LifeRisk.options.find(({value}) => type === value)?.label ?? "";
    },

    getLifeRiskColor: (risk) => {
        const colors = {
            LOW: "green",
            MEDIUM: "#f6f62e",
            HIGH: "red"
        }

        return colors[risk] ?? "#676a6c";
    }
}

export default LifeRisk;